// Configuration des types de capteurs/actionneurs pour le simulateur.
// Étendre cette table pour supporter de nouveaux types sans modifier le code du simulateur.

import {
  Thermometer, Droplets, Wind, Activity, Eye, Cpu, Zap, Gauge, Radio,
  Camera, Sun, BatteryFull, Waves, Volume2, Flame, Power
} from 'lucide-react';

const TYPES = {
  // ── Capteurs ──
  'Capteur Température': { icon: Thermometer, color: 'text-orange-400', bg: 'bg-orange-500/20', unit: '°C', min: -10, max: 50, step: 0.5 },
  'Capteur Humidité': { icon: Droplets, color: 'text-blue-400', bg: 'bg-blue-500/20', unit: '%', min: 0, max: 100, step: 1 },
  'Capteur Humidité Sol': { icon: Droplets, color: 'text-emerald-400', bg: 'bg-emerald-500/20', unit: '%', min: 0, max: 100, step: 1 },
  'Capteur CO2': { icon: Wind, color: 'text-green-400', bg: 'bg-green-500/20', unit: 'ppm', min: 300, max: 2000, step: 10 },
  'Capteur Pression': { icon: Activity, color: 'text-purple-400', bg: 'bg-purple-500/20', unit: 'hPa', min: 950, max: 1050, step: 1 },
  'Capteur Qualité Air': { icon: Wind, color: 'text-teal-400', bg: 'bg-teal-500/20', unit: 'AQI', min: 0, max: 500, step: 1 },
  'Capteur Niveau': { icon: Waves, color: 'text-cyan-400', bg: 'bg-cyan-500/20', unit: 'cm', min: 0, max: 500, step: 1 },
  'Capteur Luminosité': { icon: Sun, color: 'text-yellow-400', bg: 'bg-yellow-500/20', unit: 'lux', min: 0, max: 100000, step: 100 },
  'Capteur Bruit': { icon: Volume2, color: 'text-indigo-400', bg: 'bg-indigo-500/20', unit: 'dB', min: 0, max: 140, step: 1 },
  'Capteur Mouvement': { icon: Activity, color: 'text-pink-400', bg: 'bg-pink-500/20', unit: '', min: 0, max: 1, step: 1 },
  'Capteur Flamme': { icon: Flame, color: 'text-red-400', bg: 'bg-red-500/20', unit: '', min: 0, max: 1, step: 1 },
  'Capteur Batterie': { icon: BatteryFull, color: 'text-lime-400', bg: 'bg-lime-500/20', unit: '%', min: 0, max: 100, step: 1 },
  'Caméra IP': { icon: Eye, color: 'text-pink-400', bg: 'bg-pink-500/20', unit: '', min: 0, max: 1, step: 1 },

  // ── Actionneurs ──
  'Pompe': { icon: Activity, color: 'text-blue-500', bg: 'bg-blue-500/20', unit: '', min: 0, max: 1, step: 1, isBoolean: true },
  'Électrovanne': { icon: Gauge, color: 'text-cyan-500', bg: 'bg-cyan-500/20', unit: '', min: 0, max: 1, step: 1, isBoolean: true },
  'Vanne': { icon: Gauge, color: 'text-cyan-500', bg: 'bg-cyan-500/20', unit: '', min: 0, max: 1, step: 1, isBoolean: true },
  'Moteur': { icon: Activity, color: 'text-orange-500', bg: 'bg-orange-500/20', unit: '', min: 0, max: 1, step: 1, isBoolean: true },
  'Relais': { icon: Zap, color: 'text-yellow-500', bg: 'bg-yellow-500/20', unit: '', min: 0, max: 1, step: 1, isBoolean: true },
  'Thermostat': { icon: Thermometer, color: 'text-red-500', bg: 'bg-red-500/20', unit: '°C', min: 0, max: 40, step: 0.5 },
  'Ventilateur': { icon: Wind, color: 'text-sky-500', bg: 'bg-sky-500/20', unit: '', min: 0, max: 1, step: 1, isBoolean: true },
  'Climatiseur': { icon: Wind, color: 'text-sky-500', bg: 'bg-sky-500/20', unit: '', min: 0, max: 1, step: 1, isBoolean: true },
  'Chauffage': { icon: Flame, color: 'text-orange-500', bg: 'bg-orange-500/20', unit: '', min: 0, max: 1, step: 1, isBoolean: true },
  'Lumière': { icon: Sun, color: 'text-yellow-500', bg: 'bg-yellow-500/20', unit: '', min: 0, max: 1, step: 1, isBoolean: true },
  'Sirène': { icon: Volume2, color: 'text-red-500', bg: 'bg-red-500/20', unit: '', min: 0, max: 1, step: 1, isBoolean: true },

  // ── Passerelle ──
  'LoRa Gateway': { icon: Radio, color: 'text-violet-400', bg: 'bg-violet-500/20', unit: '', min: 0, max: 1, step: 1 },
  'Passerelle': { icon: Radio, color: 'text-violet-400', bg: 'bg-violet-500/20', unit: '', min: 0, max: 1, step: 1 },
};

const DEFAULT = { icon: Cpu, color: 'text-slate-400', bg: 'bg-slate-500/20', unit: '', min: 0, max: 100, step: 1 };

export function getTypeConfig(type) {
  if (!type) return DEFAULT;
  if (TYPES[type]) return TYPES[type];
  // Fallback : essaie de matcher par préfixe ("Capteur X" → premier match commençant par "Capteur")
  const lower = type.toLowerCase();
  if (lower.startsWith('capteur')) return { ...DEFAULT, icon: Cpu };
  if (lower.startsWith('actionneur')) return { ...DEFAULT, icon: Power };
  return DEFAULT;
}

export function getActionneurIcon(type) {
  const cfg = getTypeConfig(type);
  return cfg.icon || Power;
}
